// function getFocusableElements(e){return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))}document.querySelectorAll('[id^="Details-"] summary').forEach((e=>{e.setAttribute("role","button"),e.setAttribute("aria-expanded",e.parentNode.hasAttribute("open")),e.nextElementSibling.getAttribute("id")&&e.setAttribute("aria-controls",e.nextElementSibling.id),e.addEventListener("click",(e=>{e.currentTarget.setAttribute("aria-expanded",!e.currentTarget.closest("details").hasAttribute("open"))})),e.closest("header-drawer")||e.parentElement.addEventListener("keyup",onKeyUpEscape)}));const trapFocusHandlers={};function trapFocus(e,t=e){var i=getFocusableElements(e),s=i[0],n=i[i.length-1];removeTrapFocus(),trapFocusHandlers.focusin=t=>{t.target!==e&&t.target!==n&&t.target!==s||document.addEventListener("keydown",trapFocusHandlers.keydown)},trapFocusHandlers.focusout=function(){document.removeEventListener("keydown",trapFocusHandlers.keydown)},trapFocusHandlers.keydown=function(t){"TAB"===t.code.toUpperCase()&&(t.target!==n||t.shiftKey||(t.preventDefault(),s.focus()),t.target!==e&&t.target!==s||!t.shiftKey||(t.preventDefault(),n.focus()))},document.addEventListener("focusout",trapFocusHandlers.focusout),document.addEventListener("focusin",trapFocusHandlers.focusin),t.focus()}try{document.querySelector(":focus-visible")}catch(e){focusVisiblePolyfill()}function focusVisiblePolyfill(){const e=["ARROWUP","ARROWDOWN","ARROWLEFT","ARROWRIGHT","TAB","ENTER","SPACE","ESCAPE","HOME","END","PAGEUP","PAGEDOWN"];let t=null,i=null;window.addEventListener("keydown",(t=>{e.includes(t.code.toUpperCase())&&(i=!1)})),window.addEventListener("mousedown",(e=>{i=!0})),window.addEventListener("focus",(()=>{t&&t.classList.remove("focused"),i||(t=document.activeElement,t.classList.add("focused"))}),!0)}function pauseAllMedia(){document.querySelectorAll(".js-youtube").forEach((e=>{e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")})),document.querySelectorAll(".js-vimeo").forEach((e=>{e.contentWindow.postMessage('{"method":"pause"}',"*")})),document.querySelectorAll("video").forEach((e=>e.pause())),document.querySelectorAll("product-model").forEach((e=>{e.modelViewerUI&&e.modelViewerUI.pause()}))}function removeTrapFocus(e=null){document.removeEventListener("focusin",trapFocusHandlers.focusin),document.removeEventListener("focusout",trapFocusHandlers.focusout),document.removeEventListener("keydown",trapFocusHandlers.keydown),e&&e.focus()}function onKeyUpEscape(e){if("ESCAPE"!==e.code.toUpperCase())return;const t=e.target.closest("details[open]");if(!t)return;const i=t.querySelector("summary");t.removeAttribute("open"),i.setAttribute("aria-expanded",!1),i.focus()}class QuantityInput extends HTMLElement{constructor(){super(),this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.querySelectorAll("button").forEach((e=>e.addEventListener("click",this.onButtonClick.bind(this))))}onButtonClick(e){e.preventDefault();const t=this.input.value;"plus"===e.target.name?this.input.stepUp():this.input.stepDown(),t!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}}function debounce(e,t){let i;return(...s)=>{clearTimeout(i),i=setTimeout((()=>e.apply(this,s)),t)}}function fetchConfig(e="json"){return{method:"POST",headers:{"Content-Type":"application/json",Accept:`application/${e}`}}}customElements.define("quantity-input",QuantityInput),void 0===window.Shopify&&(window.Shopify={}),Shopify.bind=function(e,t){return function(){return e.apply(t,arguments)}},Shopify.setSelectorByValue=function(e,t){for(var i=0,s=e.options.length;i<s;i++){var n=e.options[i];if(t==n.value||t==n.innerHTML)return e.selectedIndex=i,i}},Shopify.addListener=function(e,t,i){e.addEventListener?e.addEventListener(t,i,!1):e.attachEvent("on"+t,i)},Shopify.postLink=function(e,t){var i=(t=t||{}).method||"post",s=t.parameters||{},n=document.createElement("form");for(var o in n.setAttribute("method",i),n.setAttribute("action",e),s){var r=document.createElement("input");r.setAttribute("type","hidden"),r.setAttribute("name",o),r.setAttribute("value",s[o]),n.appendChild(r)}document.body.appendChild(n),n.submit(),document.body.removeChild(n)},Shopify.CountryProvinceSelector=function(e,t,i){this.countryEl=document.getElementById(e),this.provinceEl=document.getElementById(t),this.provinceContainer=document.getElementById(i.hideElement||t),Shopify.addListener(this.countryEl,"change",Shopify.bind(this.countryHandler,this)),this.initCountry(),this.initProvince()},Shopify.CountryProvinceSelector.prototype={initCountry:function(){var e=this.countryEl.getAttribute("data-default");Shopify.setSelectorByValue(this.countryEl,e),this.countryHandler()},initProvince:function(){var e=this.provinceEl.getAttribute("data-default");e&&this.provinceEl.options.length>0&&Shopify.setSelectorByValue(this.provinceEl,e)},countryHandler:function(e){var t=(n=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),i=JSON.parse(t);if(this.clearOptions(this.provinceEl),i&&0==i.length)this.provinceContainer.style.display="none";else{for(var s=0;s<i.length;s++){var n;(n=document.createElement("option")).value=i[s][0],n.innerHTML=i[s][1],this.provinceEl.appendChild(n)}this.provinceContainer.style.display=""}},clearOptions:function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},setOptions:function(e,t){var i=0;for(t.length;i<t.length;i++){var s=document.createElement("option");s.value=t[i],s.innerHTML=t[i],e.appendChild(s)}}};class MenuDrawer extends HTMLElement{constructor(){super(),this.mainDetailsToggle=this.querySelector("details"),"iPhone"===navigator.platform&&document.documentElement.style.setProperty("--viewport-height",`${window.innerHeight}px`),this.addEventListener("keyup",this.onKeyUp.bind(this)),this.addEventListener("focusout",this.onFocusOut.bind(this)),this.bindEvents()}bindEvents(){this.querySelectorAll("summary").forEach((e=>e.addEventListener("click",this.onSummaryClick.bind(this)))),this.querySelectorAll("button").forEach((e=>e.addEventListener("click",this.onCloseButtonClick.bind(this))))}onKeyUp(e){if("ESCAPE"!==e.code.toUpperCase())return;const t=e.target.closest("details[open]");t&&(t===this.mainDetailsToggle?this.closeMenuDrawer(e,this.mainDetailsToggle.querySelector("summary")):this.closeSubmenu(t))}onSummaryClick(e){const t=e.currentTarget,i=t.parentNode,s=i.closest(".has-submenu"),n=i.hasAttribute("open"),o=window.matchMedia("(prefers-reduced-motion: reduce)");function r(){trapFocus(t.nextElementSibling,i.querySelector("button")),t.nextElementSibling.removeEventListener("transitionend",r)}i===this.mainDetailsToggle?(n&&e.preventDefault(),n?this.closeMenuDrawer(e,t):this.openMenuDrawer(t)):setTimeout((()=>{i.classList.add("menu-opening"),t.setAttribute("aria-expanded",!0),s&&s.classList.add("submenu-open"),!o||o.matches?r():t.nextElementSibling.addEventListener("transitionend",r)}),100)}openMenuDrawer(e){setTimeout((()=>{this.mainDetailsToggle.classList.add("menu-opening")})),e.setAttribute("aria-expanded",!0),trapFocus(this.mainDetailsToggle,e),document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)}closeMenuDrawer(e,t=!1){void 0!==e&&(this.mainDetailsToggle.classList.remove("menu-opening"),this.mainDetailsToggle.querySelectorAll("details").forEach((e=>{e.removeAttribute("open"),e.classList.remove("menu-opening")})),this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e=>{e.classList.remove("submenu-open")})),document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),removeTrapFocus(t),this.closeAnimation(this.mainDetailsToggle))}onFocusOut(e){setTimeout((()=>{this.mainDetailsToggle.hasAttribute("open")&&!this.mainDetailsToggle.contains(document.activeElement)&&this.closeMenuDrawer()}))}onCloseButtonClick(e){const t=e.currentTarget.closest("details");this.closeSubmenu(t)}closeSubmenu(e){const t=e.closest(".submenu-open");t&&t.classList.remove("submenu-open"),e.classList.remove("menu-opening"),e.querySelector("summary").setAttribute("aria-expanded",!1),removeTrapFocus(e.querySelector("summary")),this.closeAnimation(e)}closeAnimation(e){let t;const i=s=>{void 0===t&&(t=s);s-t<400?window.requestAnimationFrame(i):(e.removeAttribute("open"),e.closest("details[open]")&&trapFocus(e.closest("details[open]"),e.querySelector("summary")))};window.requestAnimationFrame(i)}}customElements.define("menu-drawer",MenuDrawer);class HeaderDrawer extends MenuDrawer{constructor(){super()}openMenuDrawer(e){this.header=this.header||document.getElementById("shopify-section-header"),this.borderOffset=this.borderOffset||this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")?1:0,document.documentElement.style.setProperty("--header-bottom-position",`${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`),this.header.classList.add("menu-open"),setTimeout((()=>{this.mainDetailsToggle.classList.add("menu-opening")})),e.setAttribute("aria-expanded",!0),trapFocus(this.mainDetailsToggle,e),document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)}closeMenuDrawer(e,t){super.closeMenuDrawer(e,t),this.header.classList.remove("menu-open")}}customElements.define("header-drawer",HeaderDrawer);class ModalDialog extends HTMLElement{constructor(){super(),this.querySelector('[id^="ModalClose-"]').addEventListener("click",this.hide.bind(this,!1)),this.addEventListener("keyup",(e=>{"ESCAPE"===e.code.toUpperCase()&&this.hide()})),this.classList.contains("media-modal")?this.addEventListener("pointerup",(e=>{"mouse"!==e.pointerType||e.target.closest("deferred-media, product-model")||this.hide()})):this.addEventListener("click",(e=>{e.target===this&&this.hide()}))}connectedCallback(){this.moved||(this.moved=!0,document.body.appendChild(this))}show(e){this.openedBy=e;const t=this.querySelector(".template-popup");document.body.classList.add("overflow-hidden"),this.setAttribute("open",""),t&&t.loadContent(),trapFocus(this,this.querySelector('[role="dialog"]')),window.pauseAllMedia()}hide(){document.body.classList.remove("overflow-hidden"),document.body.dispatchEvent(new CustomEvent("modalClosed")),this.removeAttribute("open"),removeTrapFocus(this.openedBy),window.pauseAllMedia()}}customElements.define("modal-dialog",ModalDialog);class ModalOpener extends HTMLElement{constructor(){super();const e=this.querySelector("button");e&&e.addEventListener("click",(()=>{const t=document.querySelector(this.getAttribute("data-modal"));t&&t.show(e)}))}}customElements.define("modal-opener",ModalOpener);class DeferredMedia extends HTMLElement{constructor(){super();const e=this.querySelector('[id^="Deferred-Poster-"]');e&&e.addEventListener("click",this.loadContent.bind(this))}loadContent(e=!0){if(window.pauseAllMedia(),!this.getAttribute("loaded")){const t=document.createElement("div");t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),this.setAttribute("loaded",!0);const i=this.appendChild(t.querySelector("video, model-viewer, iframe"));e&&i.focus()}}}customElements.define("deferred-media",DeferredMedia);class SliderComponent extends HTMLElement{constructor(){if(super(),this.slider=this.querySelector('[id^="Slider-"]'),this.sliderItems=this.querySelectorAll('[id^="Slide-"]'),this.enableSliderLooping=!1,this.currentPageElement=this.querySelector(".slider-counter--current"),this.pageTotalElement=this.querySelector(".slider-counter--total"),this.prevButton=this.querySelector('button[name="previous"]'),this.nextButton=this.querySelector('button[name="next"]'),!this.slider||!this.nextButton)return;this.initPages();new ResizeObserver((e=>this.initPages())).observe(this.slider),this.slider.addEventListener("scroll",this.update.bind(this)),this.prevButton.addEventListener("click",this.onButtonClick.bind(this)),this.nextButton.addEventListener("click",this.onButtonClick.bind(this))}initPages(){this.sliderItemsToShow=Array.from(this.sliderItems).filter((e=>e.clientWidth>0)),this.sliderItemsToShow.length<2||(this.sliderItemOffset=this.sliderItemsToShow[1].offsetLeft-this.sliderItemsToShow[0].offsetLeft,this.slidesPerPage=Math.floor((this.slider.clientWidth-this.sliderItemsToShow[0].offsetLeft)/this.sliderItemOffset),this.totalPages=this.sliderItemsToShow.length-this.slidesPerPage+1,this.update())}resetPages(){this.sliderItems=this.querySelectorAll('[id^="Slide-"]'),this.initPages()}update(){const e=this.currentPage;this.currentPage=Math.round(this.slider.scrollLeft/this.sliderItemOffset)+1,this.currentPageElement&&this.pageTotalElement&&(this.currentPageElement.textContent=this.currentPage,this.pageTotalElement.textContent=this.totalPages),this.currentPage!=e&&this.dispatchEvent(new CustomEvent("slideChanged",{detail:{currentPage:this.currentPage,currentElement:this.sliderItemsToShow[this.currentPage-1]}})),this.enableSliderLooping||(this.isSlideVisible(this.sliderItemsToShow[0])&&0===this.slider.scrollLeft?this.prevButton.setAttribute("disabled","disabled"):this.prevButton.removeAttribute("disabled"),this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length-1])?this.nextButton.setAttribute("disabled","disabled"):this.nextButton.removeAttribute("disabled"))}isSlideVisible(e,t=0){const i=this.slider.clientWidth+this.slider.scrollLeft-t;return e.offsetLeft+e.clientWidth<=i&&e.offsetLeft>=this.slider.scrollLeft}onButtonClick(e){e.preventDefault();const t=e.currentTarget.dataset.step||1;this.slideScrollPosition="next"===e.currentTarget.name?this.slider.scrollLeft+t*this.sliderItemOffset:this.slider.scrollLeft-t*this.sliderItemOffset,this.slider.scrollTo({left:this.slideScrollPosition})}}customElements.define("slider-component",SliderComponent);class SlideshowComponent extends SliderComponent{constructor(){super(),this.sliderControlWrapper=this.querySelector(".slider-buttons"),this.enableSliderLooping=!0,this.sliderControlWrapper&&(this.sliderFirstItemNode=this.slider.querySelector(".slideshow__slide"),this.sliderItemsToShow.length>0&&(this.currentPage=1),this.sliderControlLinksArray=Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")),this.sliderControlLinksArray.forEach((e=>e.addEventListener("click",this.linkToSlide.bind(this)))),this.slider.addEventListener("scroll",this.setSlideVisibility.bind(this)),this.setSlideVisibility(),"true"===this.slider.getAttribute("data-autoplay")&&this.setAutoPlay())}setAutoPlay(){this.sliderAutoplayButton=this.querySelector(".slideshow__autoplay"),this.autoplaySpeed=1e3*this.slider.dataset.speed,this.sliderAutoplayButton.addEventListener("click",this.autoPlayToggle.bind(this)),this.addEventListener("mouseover",this.focusInHandling.bind(this)),this.addEventListener("mouseleave",this.focusOutHandling.bind(this)),this.addEventListener("focusin",this.focusInHandling.bind(this)),this.addEventListener("focusout",this.focusOutHandling.bind(this)),this.play(),this.autoplayButtonIsSetToPlay=!0}onButtonClick(e){super.onButtonClick(e);const t=1===this.currentPage,i=this.currentPage===this.sliderItemsToShow.length;(t||i)&&(t&&"previous"===e.currentTarget.name?this.slideScrollPosition=this.slider.scrollLeft+this.sliderFirstItemNode.clientWidth*this.sliderItemsToShow.length:i&&"next"===e.currentTarget.name&&(this.slideScrollPosition=0),this.slider.scrollTo({left:this.slideScrollPosition}))}update(){super.update(),this.sliderControlButtons=this.querySelectorAll(".slider-counter__link"),this.prevButton.removeAttribute("disabled"),this.sliderControlButtons.length&&(this.sliderControlButtons.forEach((e=>{e.classList.remove("slider-counter__link--active"),e.removeAttribute("aria-current")})),this.sliderControlButtons[this.currentPage-1].classList.add("slider-counter__link--active"),this.sliderControlButtons[this.currentPage-1].setAttribute("aria-current",!0))}autoPlayToggle(){this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),this.autoplayButtonIsSetToPlay?this.pause():this.play(),this.autoplayButtonIsSetToPlay=!this.autoplayButtonIsSetToPlay}focusOutHandling(e){const t=e.target===this.sliderAutoplayButton||this.sliderAutoplayButton.contains(e.target);this.autoplayButtonIsSetToPlay&&!t&&this.play()}focusInHandling(e){(e.target===this.sliderAutoplayButton||this.sliderAutoplayButton.contains(e.target))&&this.autoplayButtonIsSetToPlay?this.play():this.autoplayButtonIsSetToPlay&&this.pause()}play(){this.slider.setAttribute("aria-live","off"),clearInterval(this.autoplay),this.autoplay=setInterval(this.autoRotateSlides.bind(this),this.autoplaySpeed)}pause(){this.slider.setAttribute("aria-live","polite"),clearInterval(this.autoplay)}togglePlayButtonState(e){e?(this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),this.sliderAutoplayButton.setAttribute("aria-label",window.accessibilityStrings.playSlideshow)):(this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"),this.sliderAutoplayButton.setAttribute("aria-label",window.accessibilityStrings.pauseSlideshow))}autoRotateSlides(){const e=this.currentPage===this.sliderItems.length?0:this.slider.scrollLeft+this.slider.querySelector(".slideshow__slide").clientWidth;this.slider.scrollTo({left:e})}setSlideVisibility(){this.sliderItemsToShow.forEach(((e,t)=>{const i=e.querySelector("a");t===this.currentPage-1?(i&&i.removeAttribute("tabindex"),e.setAttribute("aria-hidden","false"),e.removeAttribute("tabindex")):(i&&i.setAttribute("tabindex","-1"),e.setAttribute("aria-hidden","true"),e.setAttribute("tabindex","-1"))}))}linkToSlide(e){e.preventDefault();const t=this.slider.scrollLeft+this.sliderFirstItemNode.clientWidth*(this.sliderControlLinksArray.indexOf(e.currentTarget)+1-this.currentPage);this.slider.scrollTo({left:t})}}customElements.define("slideshow-component",SlideshowComponent);class VariantSelects extends HTMLElement{constructor(){super(),this.addEventListener("change",this.onVariantChange)}onVariantChange(){this.updateOptions(),this.updateMasterId(),this.toggleAddButton(!0,"",!1),this.updatePickupAvailability(),this.removeErrorMessage(),this.currentVariant?(this.updateURL(),this.updateVariantInput(),this.renderProductInfo(),this.updateShareUrl()):(this.toggleAddButton(!0,"",!0),this.setUnavailable())}updateOptions(){this.options=Array.from(this.querySelectorAll("select"),(e=>e.value))}updateMasterId(){this.currentVariant=this.getVariantData().find((e=>!e.options.map(((e,t)=>this.options[t]===e)).includes(!1)))}updateURL(){this.currentVariant&&"false"!==this.dataset.updateUrl&&window.history.replaceState({},"",`${this.dataset.url}?variant=${this.currentVariant.id}`)}updateShareUrl(){const e=document.getElementById(`Share-${this.dataset.section}`);e&&e.updateUrl&&e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)}updateVariantInput(){document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((e=>{const t=e.querySelector('input[name="id"]');t.value=this.currentVariant.id,t.dispatchEvent(new Event("change",{bubbles:!0}))}))}updatePickupAvailability(){const e=document.querySelector("pickup-availability");e&&(this.currentVariant&&this.currentVariant.available?e.fetchAvailability(this.currentVariant.id):(e.removeAttribute("available"),e.innerHTML=""))}removeErrorMessage(){const e=this.closest("section");if(!e)return;const t=e.querySelector("product-form");t&&t.handleErrorMessage()}renderProductInfo(){fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then((e=>e.text())).then((e=>{const t=(new DOMParser).parseFromString(e,"text/html"),i=document.getElementById(`price-${this.dataset.section}`),s=t.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);s&&i&&(i.innerHTML=s.innerHTML);const n=document.getElementById(`price-${this.dataset.section}`);n&&n.classList.remove("visibility-hidden"),this.toggleAddButton(!this.currentVariant.available,window.variantStrings.soldOut)}))}toggleAddButton(e=!0,t,i=!0){const s=document.getElementById(`product-form-${this.dataset.section}`);if(!s)return;const n=s.querySelector('[name="add"]'),o=s.querySelector('[name="add"] > span');n&&(e?(n.setAttribute("disabled","disabled"),t&&(o.textContent=t)):(n.removeAttribute("disabled"),o.textContent=window.variantStrings.addToCart))}setUnavailable(){const e=document.getElementById(`product-form-${this.dataset.section}`),t=e.querySelector('[name="add"]'),i=e.querySelector('[name="add"] > span'),s=document.getElementById(`price-${this.dataset.section}`);t&&(i.textContent=window.variantStrings.unavailable,s&&s.classList.add("visibility-hidden"))}getVariantData(){return this.variantData=this.variantData||JSON.parse(this.querySelector('[type="application/json"]').textContent),this.variantData}}customElements.define("variant-selects",VariantSelects);class VariantRadios extends VariantSelects{constructor(){super()}updateOptions(){const e=Array.from(this.querySelectorAll("fieldset"));this.options=e.map((e=>Array.from(e.querySelectorAll("input")).find((e=>e.checked)).value))}}customElements.define("variant-radios",VariantRadios);var t=$(".jdgm-rev-widg").attr("data-average-rating"),i=parseFloat(t).toFixed(1);$(".jdgm-rev-widg__summary-stars").prepend('<span class="append_rating">'+i+"</span>");var o=$(".jdgm-rev-widg").attr("data-number-of-reviews");o=parseFloat(o).toFixed(0),$(".number_of_reviews").prepend("("+o+")"),$(document).ready((function(){var e=setInterval((function(){var t=$("#judgeme_product_reviews").length;if(t>0){$(".jdgm-rev-widg__body").width();var i=$(".jdgm-sort-dropdown  option:selected").text();$(".jdgm-rev-widg__sort-wrapper").append('<br><span class="message_review">'+i+" From Our Customers</span>"),console.log("show reviews title"+t),clearInterval(e)}}),1e3);$(document).on("change",".jdgm-sort-dropdown",(function(){$(".message_review").remove(),setTimeout((function(){var e=$(".jdgm-sort-dropdown  option:selected").text();$(".jdgm-rev-widg__sort-wrapper").append('<span class="message_review">'+e+" From Our Customers</span>"),console.log("show reviews title")}),3e3)}))}));

function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
        e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
        e.addEventListener("click", (e) => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
        }),
        e.closest("header-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        s = i[0],
        n = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== n && t.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t.target !== e && t.target !== s) || !t.shiftKey || (t.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    const e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let t = null,
        i = null;
    window.addEventListener("keydown", (t) => {
        e.includes(t.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (e) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                t && t.classList.remove("focused"), i || ((t = document.activeElement), t.classList.add("focused"));
            },
            !0
        );
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    if (!t) return;
    const i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), (this.input = this.querySelector("input")), (this.changeEvent = new Event("change", { bubbles: !0 })), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
customElements.define("quantity-input", QuantityInput),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, s = e.options.length; i < s; i++) {
            var n = e.options[i];
            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i = (t = t || {}).method || "post",
            s = t.parameters || {},
            n = document.createElement("form");
        for (var o in (n.setAttribute("method", i), n.setAttribute("action", e), s)) {
            var r = document.createElement("input");
            r.setAttribute("type", "hidden"), r.setAttribute("name", o), r.setAttribute("value", s[o]), n.appendChild(r);
        }
        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                i = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var n;
                    ((n = document.createElement("option")).value = i[s][0]), (n.innerHTML = i[s][1]), this.provinceEl.appendChild(n);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var i = 0;
            for (t.length; i < t.length; i++) {
                var s = document.createElement("option");
                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
            }
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(),
            (this.mainDetailsToggle = this.querySelector("details")),
            "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            i = t.parentNode,
            s = i.closest(".has-submenu"),
            n = i.hasAttribute("open"),
            o = window.matchMedia("(prefers-reduced-motion: reduce)");
        function r() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", r);
        }
        i === this.mainDetailsToggle
            ? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
            : setTimeout(() => {
                  i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !o || o.matches ? r() : t.nextElementSibling.addEventListener("transitionend", r);
              }, 100); 
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
                e.classList.remove("submenu-open");
            }),
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        const t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(e.querySelector("summary")), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t;
        const i = (s) => {
            void 0 === t && (t = s);
            s - t < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
        };
        window.requestAnimationFrame(i);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            this.header.classList.add("menu-open"),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t) {
        super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open");
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      e.target === this && this.hide();
                  });
    }
    connectedCallback() {
        this.moved || ((this.moved = !0), document.body.appendChild(this));
    }
    show(e) {
        this.openedBy = e;
        const t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("button");
        e &&
            e.addEventListener("click", () => {
                const t = document.querySelector(this.getAttribute("data-modal"));
                t && t.show(e);
            });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector('[id^="Deferred-Poster-"]');
        e && e.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(e = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            const t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            const i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            e && i.focus();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector('[id^="Slider-"]')),
            (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
            (this.enableSliderLooping = !1),
            (this.currentPageElement = this.querySelector(".slider-counter--current")),
            (this.pageTotalElement = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            !this.slider || !this.nextButton)
        )
            return;
        this.initPages();
        new ResizeObserver((e) => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
            const dots = this.querySelectorAll('.slider_dots');

                // Iterate over each dot element
                if(dots.length > 0){
                dots.forEach(dot => {
                    // Add click event listener to each dot
                    dot.addEventListener('click', this.dotClick.bind(this));
                });
            }
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
            this.sliderItemsToShow.length < 2 ||
                ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                (this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)),
                (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
                this.update());
    }
    resetPages() {
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
    }
    update() {
        const e = this.currentPage;
        (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
            this.currentPageElement && this.pageTotalElement && ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != e && this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } })),
            this.enableSliderLooping ||
                (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
                this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"));
    }
    isSlideVisible(e, t = 0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = e.currentTarget.dataset.step || 1;
        (this.slideScrollPosition = "next" === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset), this.slider.scrollTo({ left: this.slideScrollPosition });
    }
    dotClick(e){
        e.preventDefault();
        let t = e.currentTarget.dataset.step || 1;
         this.slideScrollPosition =  this.slider.scrollLeft + t * this.sliderItemOffset;
        if(Number(t) > this.currentPage)  this.slideScrollPosition =  this.slider.scrollLeft + t * this.sliderItemOffset ; 
        if(Number(t) < this.currentPage)  this.slideScrollPosition =  this.slider.scrollLeft - t * this.sliderItemOffset ; 
        // Select all elements with the class 'slider_dots'
                const dots = e.currentTarget.closest('.slider-buttons').querySelectorAll('.slider_dots');

                // Iterate over each dot element
                dots.forEach(dot => {
                    // Remove the class 'active' from each dot
                    dot.classList.remove('active');
                });
                e.currentTarget.classList.add('active')
       this.slider.scrollTo({ left: this.slideScrollPosition });

    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super(),
            (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
            (this.enableSliderLooping = !0),
            this.sliderControlWrapper &&
                ((this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
                this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
                (this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"))),
                this.sliderControlLinksArray.forEach((e) => e.addEventListener("click", this.linkToSlide.bind(this))),
                this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
                this.setSlideVisibility(),
                "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay());
    }
    setAutoPlay() {
        (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
            (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
            this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)),
            this.addEventListener("mouseover", this.focusInHandling.bind(this)),
            this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
            this.addEventListener("focusin", this.focusInHandling.bind(this)),
            this.addEventListener("focusout", this.focusOutHandling.bind(this)),
            this.play(),
            (this.autoplayButtonIsSetToPlay = !0);
    }
    onButtonClick(e) {
        super.onButtonClick(e);
        const t = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        (t || i) &&
            (t && "previous" === e.currentTarget.name
                ? (this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
                : i && "next" === e.currentTarget.name && (this.slideScrollPosition = 0),
            this.slider.scrollTo({ left: this.slideScrollPosition }));
    }
    update() {
        super.update(),
            (this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")),
            this.prevButton.removeAttribute("disabled"),
            this.sliderControlButtons.length &&
                (this.sliderControlButtons.forEach((e) => {
                    e.classList.remove("slider-counter__link--active"), e.removeAttribute("aria-current");
                }),
                this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"),
                this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0));
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
    }
    focusOutHandling(e) {
        const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
        this.autoplayButtonIsSetToPlay && !t && this.play();
    }
    focusInHandling(e) {
        (e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause();
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay);
    }
    togglePlayButtonState(e) {
        e
            ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow))
            : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow));
    }
    autoRotateSlides() {
        const e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({ left: e });
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach((e, t) => {
            const i = e.querySelector("a");
            t === this.currentPage - 1
                ? (i && i.removeAttribute("tabindex"), e.setAttribute("aria-hidden", "false"), e.removeAttribute("tabindex"))
                : (i && i.setAttribute("tabindex", "-1"), e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1"));
        });
    }
    linkToSlide(e) {
        e.preventDefault();
        const t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: t });
    }
}
customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.removeErrorMessage(),
            this.currentVariant ? (this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
        const e = document.getElementById(`Share-${this.dataset.section}`);
        e && e.updateUrl && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((e) => {
            const t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    removeErrorMessage() {
        const e = this.closest("section");
        if (!e) return;
        const t = e.querySelector("product-form");
        t && t.handleErrorMessage();
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((e) => e.text())
            .then((e) => {
                const t = new DOMParser().parseFromString(e, "text/html"),
                    i = document.getElementById(`price-${this.dataset.section}`),
                    s = t.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                s && i && (i.innerHTML = s.innerHTML);
                const n = document.getElementById(`price-${this.dataset.section}`);
                n && n.classList.remove("hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }
    toggleAddButton(e = !0, t, i = !0) {
        const s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s) return;
        const n = s.querySelector('[name="add"]'),
            o = s.querySelector('[name="add"] > span');
        n && (e ? (n.setAttribute("disabled", "disabled"), t && (o.textContent = t)) : (n.removeAttribute("disabled"), (o.textContent = window.variantStrings.addToCart)));
    }
    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelector('[name="add"] > span'),
            s = document.getElementById(`price-${this.dataset.section}`);
        t && ((i.textContent = window.variantStrings.unavailable), s && s.classList.add("hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        const e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
    }
}
customElements.define("variant-radios", VariantRadios);

class NewVariantSelects extends HTMLElement {
    constructor() {
        super(), 
        this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
            this.updateOptions(),
            this.updateMasterId();
            this.toggleAddButton(!0, "", !1);
            this.updatePickupAvailability();
            this.removeErrorMessage();
            this.updateVariantStatuses();
            if (!this.currentVariant) {
              this.toggleAddButton(!0, "", !0);
              // this.setUnavailable();
            } else {
              this.updateVariantInput();
              this.renderProductInfo();
              this.updateShareUrl();
            }
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
        const e = document.getElementById(`Share-${this.dataset.section}`);
        e && e.updateUrl && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((e) => {
            const t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    removeErrorMessage() {
        const e = this.closest("section");
        if (!e) return;
        const t = e.querySelector("product-form");
        t && t.handleErrorMessage();
    }
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;
  
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('hidden');
  
          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
  
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
  
          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        });
    }
    toggleAddButton(e = !0, t, i = !0) {
          const s = document.getElementById(`product-form-${this.dataset.section}`);
      
          if (!s) return;
          const n = s.querySelector('[name="add"]'),
              o = s.querySelector('[name="add"] > span');
          n && (e ? (n.setAttribute("disabled", "disabled"), t && (o.textContent = t)) : (n.removeAttribute("disabled"),
            (o.textContent = `ADD TO CART`)
         ));
      
      }
    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelector('[name="add"] > span'),
            s = document.getElementById(`price-${this.dataset.section}`);
        t && ((i.textContent = window.variantStrings.unavailable), s && s.classList.add("hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("new-variant-selects", NewVariantSelects);

class NewVariantRadios extends NewVariantSelects {
    constructor() {
        super();
    }
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input, index) => {
          if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
            input.classList.remove('disabled');
          } else {
            input.classList.add('disabled');
          }
        });
    }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    } 
}
customElements.define("new-variant-radios", NewVariantRadios);
 

  window.addEventListener('DOMContentLoaded', (event) => {
 

      $('new-variant-radios .option_1 .input-option').click(function() {
          var optionInput = $(this).parents().find('.option-size.disabled');
          var swatchImages = $(".dm-swatch-images img");
          var swatchImagesArray = Array.from(swatchImages);
          var optionInputArray = Array.from(optionInput);
          var optionColor = $(this).val();
          console.log(optionColor);
          if(swatchImagesArray.length > 1) {
            swatchImagesArray.forEach((image) => {
               var imageColor = image.dataset.color;
               console.log(imageColor);
               if(imageColor == optionColor) {
                  console.log("True");
                  image.classList.remove("dm-hide");
               }
              else {
                console.log("False");
                image.classList.add("dm-hide");
              }
            }); 
           }
          
           if(optionInputArray.length > 0) {
               optionInputArray.every((option, index) => {
                var firstOption = option;
                if(index == 0 ) {
                    firstOption.click();
                    return false;
                }
                return true;
               });
            }
       });
    
  });